import type { DiagnosticSnapshot } from "@/api/diagnostic";

import { num, rec } from "../diagnosticData";

type Validation = DiagnosticSnapshot["validation"];

/**
 * O valor do projeto pela calibragem comercial (EF-FUNC-012 v0.3 RF-03).
 *
 * - `ready`: o cenário marcado, com os quatro valores do card;
 * - `awaiting`: nenhuma versão salva ou nenhum cenário marcado;
 * - `unavailable`: o domínio falhou ou não veio, e o card não afirma nada.
 */
export type CommercialOffer =
  | {
      state: "ready";
      offered: number;
      original: number;
      exedIncentive: number;
      hyperscaleFunding: number;
    }
  | { state: "awaiting" }
  | { state: "unavailable" };

/** O cenário marcado, do domínio `validation.commercial_offer`. */
export function commercialOffer(validation: Validation | undefined): CommercialOffer {
  const envelope = validation?.commercial_offer;
  if (envelope?.state === "empty") return { state: "awaiting" };
  if (envelope?.state !== "ok") return { state: "unavailable" };
  const data = rec(envelope.data);
  const offered = num(data.offered_value);
  const original = num(data.original_value);
  const exedIncentive = num(data.exed_incentive);
  const hyperscaleFunding = num(data.hyperscale_funding);
  if (
    offered === undefined ||
    original === undefined ||
    exedIncentive === undefined ||
    hyperscaleFunding === undefined
  ) {
    return { state: "unavailable" };
  }
  return { state: "ready", offered, original, exedIncentive, hyperscaleFunding };
}
